package top.wcpe.allincore.dsl.compiler.pipeline

import top.wcpe.allincore.dsl.compiler.theme.ThemeDerivation

/**
 * 主题派生 Pass：对注册表中每个含种子（`seed.*`）的 scheme，调用 [ThemeDerivation] 由少量
 * 种子色/基数派生补全缺失 token 后回写注册表。无种子的主题原样跳过（零回归）。
 *
 * 运行时机：[ThemeCollectorPass] 之后、[ThemeMergePass] 之前。此时注册表已收齐全部主题预设，
 * 派生结果既进入运行时 availableThemes（供 `local.setTheme` 切换），又能被 screen 引用与
 * 后续编译期 token 校验覆盖。
 */
class DerivativeThemePass(
    private val registry: ThemeRegistry,
) {

    /** 遍历全部 scheme，对含种子者派生回写（present-wins，已写出的 token 不覆盖）。 */
    fun derive() {
        for (scheme in registry.schemes().toList()) {
            val tokens = registry.lookup(scheme) ?: continue
            if (!ThemeDerivation.hasSeed(tokens)) continue
            registry.register(scheme, ThemeDerivation.derive(LinkedHashMap(tokens)))
        }
    }
}
